import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LeadHeader } from '../components/leads/LeadHeader';
import { LeadContactBlock } from '../components/leads/LeadContactBlock';
import { LeadFieldsPanel } from '../components/leads/LeadFieldsPanel';
import { ScoreBreakdown } from '../components/leads/ScoreBreakdown';
import { LeadTimeline } from '../components/leads/LeadTimeline';
import { mockLeads } from '../data/mockLeads';
import { Lead, LeadState, Interaction } from '../types/lead';
const mockInteractions: Interaction[] = [{
  id: '1',
  leadId: 'L-004',
  type: 'WA',
  content: 'Enviado mensaje de contacto inicial',
  timestamp: '2026-05-08T10:00:00Z',
  userId: 'U-001'
}, {
  id: '2',
  leadId: 'L-004',
  type: 'WA',
  content: 'Respuesta: "Vale, envíame esa propuesta de 1 página a ver qué tal."',
  timestamp: '2026-05-09T14:20:00Z',
  userId: 'U-001'
}, {
  id: '3',
  leadId: 'L-004',
  type: 'StateChange',
  content: 'Estado cambiado a Micro-acuerdo',
  timestamp: '2026-05-09T14:25:00Z',
  userId: 'U-001'
}];
export function LeadDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const [lead, setLead] = useState<Lead | null>(null);
  useEffect(() => {
    // In a real app, fetch from API
    const found = mockLeads.find(l => l.id === id);
    if (found) setLead(found);
  }, [id]);
  if (!lead) return <div className="p-8 text-growthly-muted" data-id="element-719">Cargando...</div>;
  const handleStateChange = (newState: LeadState) => {
    setLead({
      ...lead,
      STATE: newState
    });
  };
  const handleFieldChange = (field: keyof Lead, value: any) => {
    setLead({
      ...lead,
      [field]: value
    });
  };
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto pb-24 md:pb-8" data-id="element-720">
      <button onClick={() => navigate('/leads')} className="flex items-center text-[13px] font-medium text-growthly-muted hover:text-growthly-text mb-4 transition-colors" data-id="element-721">
        <ArrowLeft className="w-4 h-4 mr-1" data-id="element-722" /> Volver a Leads
      </button>

      <LeadHeader lead={lead} onStateChange={handleStateChange} data-id="element-723" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-724">
        {/* Left Column - Contact Info */}
        <div className="lg:col-span-3" data-id="element-725">
          <LeadContactBlock lead={lead} data-id="element-726" />
        </div>

        {/* Center Column - Fields & Score */}
        <div className="lg:col-span-5 space-y-6" data-id="element-727">
          <LeadFieldsPanel lead={lead} onChange={handleFieldChange} data-id="element-728" />
          <ScoreBreakdown lead={lead} data-id="element-729" />
        </div>

        {/* Right Column - Timeline */}
        <div className="lg:col-span-4" data-id="element-730">
          <LeadTimeline interactions={mockInteractions} data-id="element-731" />
        </div>
      </div>
    </div>;
}